import type { Group } from '../../features/access/types';
import { useUserGroupsQuery } from '../../features/access/hooks/use-user-groups-query';
import { useSelectedRootLocationConfiguration } from '../../features/app-config/hooks/use-selected-root-location-configuration';
import {
  extractDatasetIdsRead,
  extractDatasetIdsWrite,
} from '../../utils/timeseriesAccess';

export const selectUserTimeseriesAccess = (
  groups: Group[],
  datasetId: number | undefined
): boolean => {
  const idsWithReadAccess = extractDatasetIdsRead(groups);
  const idsWithWriteAccess = extractDatasetIdsWrite(groups);

  const hasReadAccess =
    idsWithReadAccess.includes('all') ||
    (Boolean(datasetId) && idsWithReadAccess.includes(String(datasetId)));

  const hasWriteAccess =
    idsWithWriteAccess.includes('all') ||
    (Boolean(datasetId) && idsWithWriteAccess.includes(String(datasetId)));

  return hasReadAccess && hasWriteAccess;
};

export const useUserTimeseriesAccess = () => {
  const configuredRootLocation = useSelectedRootLocationConfiguration();
  const datasetId = configuredRootLocation?.dataSetId;

  return useUserGroupsQuery<boolean>((groups) =>
    selectUserTimeseriesAccess(groups, datasetId)
  );
};
